// extracted by mini-css-extract-plugin
module.exports = {"paymentHistory":"styles_paymentHistory__2d6kB"};